import { render, staticRenderFns } from "./CargoQuotePosted.vue?vue&type=template&id=3594221b&"
import script from "./CargoQuotePosted.vue?vue&type=script&lang=js&"
export * from "./CargoQuotePosted.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuotePosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuotePosted.vue"
export default component.exports